import { render, staticRenderFns } from "./LabelReleasesCoverImageUploadDialog.vue?vue&type=template&id=0248c066"
import script from "./LabelReleasesCoverImageUploadDialog.vue?vue&type=script&lang=js"
export * from "./LabelReleasesCoverImageUploadDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports